module.exports = __webpack_public_path__ + "dea8d12a9c0eacd54fee7a5ded27bcb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/13_PROP_VET_08.png
// module id = 114
// module chunks = 0